import { ResultSet } from "@cubejs-client/core";
import { DateTime } from "luxon";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export const loadSalesReferenceDate = (): AppThunk<Promise<DateTime>> => async (dispatch) => {
    try {
        const query = {
            measures: ["F_Sales.MaxFK_OrderDate"]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        const referenceDateString = String(resultSet.rawData()[0]["F_Sales.MaxFK_OrderDate"]);
        return DateTime.fromFormat(referenceDateString, "yyyyMMdd", { zone: "utc" });
    } catch (error) {
        dispatch(logError("Error loading SalesReferenceDate.", error));
        throw error;
    }
};
